import MediaInfoForm from './MediaInfoForm';

export default MediaInfoForm;
